import request from './AxiosRequest';

const phoneview = params =>
    request({
        url: `/Services/api/notifications/phoneview`,
        method: 'POST',
        data: params
    });

const notifications = {
    phoneview
};

export default notifications;
